import type { Menu } from '@/menus/types.ts';

export default [
  {
    code: 'LOGISTICS',
    icon: 'menu-logistics',
    label: '物流管理',
    children: [
      {
        code: 'LOGISTICS_FOLLOW_UP',
        icon: 'menu-logistics-follow-up',
        label: '物流跟进',
        path: '/logistics/follow-up',
      },
      {
        code: 'LOGISTICS_DOMESTIC',
        icon: 'menu-domestic-logistics',
        label: '国内物流',
        path: '/logistics/domestic',
      },
      {
        code: 'LOGISTICS_INTERNATIONAL',
        icon: 'menu-international-logistics',
        label: '国际物流',
        path: '/logistics/international',
      },
    ],
  },
] satisfies Menu[];
